// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__KOzx3","menu":"style_menu__1aYEc","locale":"style_locale__xKjmo","active":"style_active__12_2w","fadein":"style_fadein__1Misd"};